import PropTypes from 'prop-types';

export const manualAccountsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    accountDescription: PropTypes.string.isRequired,
    accountId: PropTypes.string.isRequired,
    legalEntityAmt: PropTypes.number.isRequired,
  }),
);
